import { render } from "./InvCategorias.vue?vue&type=template&id=22791b90&scoped=true"
import script from "./InvCategorias.vue?vue&type=script&lang=js"
export * from "./InvCategorias.vue?vue&type=script&lang=js"

import "./InvCategorias.vue?vue&type=style&index=0&id=22791b90&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22791b90"]])

export default __exports__